export default "__VITE_ASSET__nIGroLY$__"